import React, { useState, useEffect } from 'react';
import { Grid, Select, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';

import { BeatLoader } from 'react-spinners';

import * as Yup from 'yup';
import { Formik } from 'formik';
import { blockReasons } from './constant';
import { UserService } from 'services/api/user';
import { errorService } from 'services/alert/services';

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
    flexDirection: 'column',
  },
  form: {
    width: 500,
    margin: '0 0',
  },
  cellItem: {
    width: '100%',
    margin: '0 0 15px',
  },
  loaderContainer: {
    width: 450,
  },
  padding: { padding: 4 },
  bold: { fontWeight: 'bolder' },
});

export const UserBlockForm = ({ profile, ...props }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = (data) => {
    props.onHandleClose(data);
    setOpen(false);
  };

  const onSubmit = async (values, actions) => {
    try {
      await UserService.update(profile._id, { blockReason: values.blockReason, blocked: true });
      if (props.onSuccess) props.onSuccess();
      handleClose();
    } catch (e) {
      errorService.sendError(e.message);
    }
  };

  if (!profile) return null;

  return (
    <div>
      <Dialog open={open} onClose={() => handleClose(false)} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Заблокировать пользователя</DialogTitle>
        <DialogContent>
          <Grid container className={classes.fullWidth}>
            <Grid item className={classes.fullWidth}>
              <Grid container className={classes.fullWidth}>
                <Formik
                  initialValues={{ blockReason: null }}
                  enableReinitialize
                  onSubmit={onSubmit}
                  render={({ values, errors, handleSubmit, handleChange, isSubmitting }) => {
                    return (
                      <form onSubmit={handleSubmit} className={classes.form}>
                        <Grid container direction="column" justify="center" alignItems="center">
                          <Grid item xs={12} className={classes.cellItem}>
                            <Select
                              fullWidth
                              label="Статус"
                              onChange={handleChange}
                              error={!!errors.blockReason}
                              name="blockReason"
                              value={values.blockReason}
                            >
                              {Object.entries(blockReasons).map(([value, label]) => {
                                return (
                                  <MenuItem key={value} value={value}>
                                    {label}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </Grid>

                          <Grid item xs={12} style={{ paddingTop: 20, width: 200 }}>
                            <Button
                              fullWidth
                              variant="contained"
                              color="primary"
                              onClick={handleSubmit}
                            >
                              {isSubmitting ? (
                                <BeatLoader size={10} color="white" loading={true} />
                              ) : (
                                'Заблокировать'
                              )}
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => handleClose(false)}>
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
